import React, { useMemo } from 'react';
import strings from 'strings';
import TabsView from 'UI/components/templates/TabsView';

import { TAB_IDS } from '../SendoutInterviewDetailsDrawer.constants';

import { DebriefingCallTabContent } from './DebriefingCallTabContent';
import { InterviewDetailsTabContent } from './InterviewDetailsTabContent';
import { PreparationCallTabContent } from './PreparationCallTabContent';
import { useStyles } from './SendoutInterviewDetailsTabs.styled';

const buildTabs = ({ interviewId, onEditDebrief, onViewDebrief }) => [
  {
    id: TAB_IDS.InterviewDetails,
    label: strings.sendoutsV2.drawers.sendoutInterviewDetails.tabs.interviewDetails.title,
    view: <InterviewDetailsTabContent interviewId={interviewId} />
  },
  {
    id: TAB_IDS.PreparationCall,
    label: strings.sendoutsV2.drawers.sendoutInterviewDetails.tabs.preparationCall.title,
    view: <PreparationCallTabContent interviewId={interviewId} />
  },
  {
    id: TAB_IDS.DebriefingCall,
    label: strings.sendoutsV2.drawers.sendoutInterviewDetails.tabs.debriefingCall.title,
    view: (
      <DebriefingCallTabContent
        interviewId={interviewId}
        onEditDebrief={onEditDebrief}
        onViewDebrief={onViewDebrief}
      />
    )
  }
];

export const SendoutInterviewDetailsTabs = ({
  interviewId,
  onChangeTabIndex,
  onEditDebrief,
  onViewDebrief,
  selectedTab
}) => {
  const classes = useStyles();
  const tabs = useMemo(
    () => buildTabs({ interviewId, onEditDebrief, onViewDebrief }),
    [interviewId, onEditDebrief, onViewDebrief]
  );

  return (
    <TabsView
      enableUrlNavigation={false}
      onChangeTabIndex={onChangeTabIndex}
      panelHeight="unset"
      selectedTab={selectedTab}
      tabs={tabs}
      useIndexes={false}
      tabsContainerProps={{ className: classes.tabsContainer }}
      padding="24px"
    />
  );
};
